import { useState } from "react";
import { Link, useNavigate, useLocation } from "react-router-dom";
import { Eye, EyeOff } from "lucide-react";
import { toast } from "sonner";
import { useAuth } from "@/lib/auth";

export default function Register() {
  const nav = useNavigate();
  const loc = useLocation();
  const next = loc.state?.next || "/test";
  const { register } = useAuth();
  const [form, setForm] = useState({ first_name: "", last_name: "", email: "", password: "" });
  const [show, setShow] = useState(false);
  const [err, setErr] = useState("");
  const [loading, setLoading] = useState(false);

  const set = (k) => (e) => setForm({ ...form, [k]: e.target.value });
  const isEmail = (v) => /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(v);

  const submit = async (e) => {
    e.preventDefault();
    setErr("");
    if (!form.first_name.trim() || !form.last_name.trim()) return setErr("Ad ve soyad zorunlu.");
    if (!isEmail(form.email.trim())) return setErr("Lütfen geçerli bir e-posta adresi gir.");
    if (form.password.length < 8) return setErr("Şifre en az 8 karakter olmalı.");
    setLoading(true);
    try {
      await register({
        first_name: form.first_name.trim(),
        last_name: form.last_name.trim(),
        email: form.email.trim().toLowerCase(),
        password: form.password,
      });
      toast.success("Hoş geldin!");
      nav(next);
    } catch (e2) {
      const d = e2?.response?.data?.detail;
      setErr(typeof d === "string" ? d : "Kayıt oluşturulamadı.");
    } finally { setLoading(false); }
  };

  return (
    <div className="max-w-md mx-auto" data-testid="register-page">
      <h1 className="text-4xl md:text-5xl font-semibold tracking-tight h-gradient">Hesap Oluştur</h1>
      <p className="mt-4 text-neutral-400">Life 101 Yaşam Skoru sonucunu sana özel hazırlayabilmemiz ve sana özel kaynaklara erişim verebilmemiz için bir hesap oluştur.</p>

      <form onSubmit={submit} className="glass mt-8 p-8 space-y-6">
        <div className="grid grid-cols-2 gap-4">
          <div>
            <label className="text-xs uppercase tracking-[0.15em] text-neutral-500">Ad</label>
            <input className="life-input" value={form.first_name} onChange={set("first_name")} autoCapitalize="words" data-testid="reg-first-name" />
          </div>
          <div>
            <label className="text-xs uppercase tracking-[0.15em] text-neutral-500">Soyad</label>
            <input className="life-input" value={form.last_name} onChange={set("last_name")} autoCapitalize="words" data-testid="reg-last-name" />
          </div>
        </div>
        <div>
          <label className="text-xs uppercase tracking-[0.15em] text-neutral-500">E-posta</label>
          <input type="email" autoCapitalize="off" autoCorrect="off" spellCheck={false} className="life-input" value={form.email} onChange={set("email")} placeholder="ornek@mail.com" data-testid="reg-email" />
        </div>
        <div>
          <label className="text-xs uppercase tracking-[0.15em] text-neutral-500">Şifre</label>
          <div className="relative">
            <input type={show ? "text" : "password"} autoCapitalize="off" autoCorrect="off" spellCheck={false} className="life-input pr-10" value={form.password} onChange={set("password")} placeholder="En az 8 karakter" data-testid="reg-password" />
            <button type="button" onClick={() => setShow(s => !s)} className="absolute right-1 top-1/2 -translate-y-1/2 text-neutral-500 hover:text-white p-1">
              {show ? <EyeOff size={16} /> : <Eye size={16} />}
            </button>
          </div>
        </div>
        {err && <div className="text-sm text-red-300/80" data-testid="reg-error">{err}</div>}
        <button type="submit" disabled={loading} className="btn-primary w-full" data-testid="reg-submit">
          {loading ? "Kayıt yapılıyor..." : "Hesap Oluştur"}
        </button>
        <p className="text-xs text-neutral-500 text-center">
          Zaten hesabın var mı? <Link to="/giris" state={{ next }} className="text-white underline" data-testid="goto-login">Giriş Yap</Link>
        </p>
        <p className="text-xs text-neutral-600 leading-relaxed">
          Bilgilerin yalnızca Life 101 skorunu, kaynakları ve raporunu kişiselleştirmek için kullanılır.
        </p>
      </form>
    </div>
  );
}
